import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { Button, Layout, Menu, Popconfirm, Radio, Spin, Tooltip } from 'antd'
import _ from 'lodash'

import * as actions from './AppActions'
import MemberListModal from '../Commons/MemberListModal/MemberListModal'
import settingIcon from '../../public/assets/images/ic_setting.svg'
import logoutIcon from '../../public/assets/images/ic_logout.svg'
import './App.scss'

const { Header, Content, Sider } = Layout
const MenuItem = Menu.Item
const RadioButton = Radio.Button

export class App extends Component {
    constructor(props) {
        super(props)

        this.state = {
            popconfirmVisibleForCompleted: false,
            popconfirmVisibleForInactive: false,
            showMemberListModal: false,
            selectedKey: ''
        }

        this.openMemberListModal = this.openMemberListModal.bind(this)
        this.closeMemberListModal = this.closeMemberListModal.bind(this)
        this.handleProjectStatusChange = this.handleProjectStatusChange.bind(this)
        this.handleLogout = this.handleLogout.bind(this)
        this.renderLeftHeader = this.renderLeftHeader.bind(this)
    }

    openMemberListModal() {
        const { fetchProjectMemberList, fetchProjectAvailableMemberList, token, selectedProject } = this.props
        const projectId = selectedProject._id

        fetchProjectMemberList(token, projectId)
        fetchProjectAvailableMemberList(token, projectId)

        this.setState({ showMemberListModal: true })
    }

    closeMemberListModal() {
        this.setState({ showMemberListModal: false })
    }

    handlePopconfirmVisibleChange(field, value, visible, isAuthorized) {
        const status = this.props.selectedProject.status

        if (!visible) {
            this.setState({
                [field]: visible
            })
            return
        }
        if (isAuthorized) {
            if (status !== 'proposed' && status !== 'active') {
                this.handleProjectStatusChange(value)
                this.setState({
                    [field]: false
                })
            } else {
                this.setState({
                    [field]: visible
                })
            }
        } else {
            this.setState({
                [field]: false
            })
        }
    }

    handleProjectStatusChange(value) {
        const { updateProjectStatus, token, selectedProject } = this.props
        const projectId = selectedProject._id

        updateProjectStatus(token, projectId, value)
    }

    handleLogout() {
        const { logout } = this.props
        localStorage.removeItem('token')
        logout()
    }

    handleMemberAdd(memberId) {
        const { addMemberToProject, token, selectedProject } = this.props
        const projectId = selectedProject._id
        addMemberToProject(token, projectId, memberId)
    }

    handleMemberRemove(memberId) {
        const { removeMemberFromProject, token, selectedProject } = this.props
        const projectId = selectedProject._id
        removeMemberFromProject(token, projectId, memberId)
    }

    handleMemberAuthChange(memberId, isAuthorized) {
        const { updateProjectMemberAuth, token, selectedProject } = this.props
        const projectId = selectedProject._id

        updateProjectMemberAuth(token, projectId, memberId, !isAuthorized)
    }

    componentWillMount() {
        const { location } = this.props
        this.setState({ selectedKey: location.pathname })
    }

    componentDidUpdate(prevProps, prevState) {
        const { fetchProjectMemberList, fetchProjectAvailableMemberList, token, location, selectedProject, isMemberAdding, isMemberRemoving, isMemberChangingAuth } = this.props
        const projectId = selectedProject._id

        if (prevProps.location.pathname !== location.pathname)
            this.setState({ selectedKey: location.pathname })

        if ((prevProps.isMemberAdding !== isMemberAdding && prevProps.isMemberAdding && !isMemberAdding) ||
            (prevProps.isMemberRemoving !== isMemberRemoving && prevProps.isMemberRemoving && !isMemberRemoving) ||
            (prevProps.isMemberChangingAuth !== isMemberChangingAuth && prevProps.isMemberChangingAuth && !isMemberChangingAuth)) {
            fetchProjectMemberList(token, projectId)
            fetchProjectAvailableMemberList(token, projectId)
        }
    }

    renderLeftHeader() {
        const { selectedProject, selectedProjectMemberList, selectedProjectAvailableMemberList, userId, userType } = this.props
        const { popconfirmVisibleForCompleted, popconfirmVisibleForInactive, showMemberListModal } = this.state

        if (!_.isEmpty(selectedProject)) {
            const { status, name, estate_name, flat, client_name, client_number, created_by, members, contact_person } = selectedProject
            const isAuthorized = created_by === userId || _.find(members, { member_id: userId, able_to_create: true }) || contact_person === userId || userType === 'admin'

            return (
                <div className="header-left">
                    <div className="project-info">
                        {name || 'N/A'} | {estate_name || 'N/A'} | { flat ? `Flat ${flat}` : 'N/A'} | {client_name || 'N/A'} | {client_number || 'N/A'}
                    </div>
                    <Button className="member-btn" type="primary" onClick={this.openMemberListModal}>Member</Button>
                    <div className="project-status-btn">
                        <RadioButton value="proposed" checked={status === 'proposed'} disabled>Proposed</RadioButton>
                        <RadioButton value="active" checked={status === 'active'} disabled>Active</RadioButton>
                        <Popconfirm 
                            placement="top" 
                            title="This action is irreversible, are you sure?" 
                            visible={popconfirmVisibleForCompleted}
                            onVisibleChange={this.handlePopconfirmVisibleChange.bind(this, 'popconfirmVisibleForCompleted', 'completed', (userType === 'admin'))}
                            onConfirm={() => this.handleProjectStatusChange('completed')} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <RadioButton value="completed" checked={status === 'completed'} disabled={userType !== 'admin'}>Completed</RadioButton>
                        </Popconfirm>
                        <Popconfirm 
                            placement="top" 
                            title="This action is irreversible, are you sure?" 
                            visible={popconfirmVisibleForInactive}
                            onVisibleChange={this.handlePopconfirmVisibleChange.bind(this, 'popconfirmVisibleForInactive', 'inactive', (userType === 'admin'))}
                            onConfirm={() => this.handleProjectStatusChange('inactive')} 
                            okText="Yes" 
                            cancelText="No"
                        >
                            <RadioButton value="inactive" checked={status === 'inactive'} disabled={userType !== 'admin'}>Inactive</RadioButton>
                        </Popconfirm>
                    </div>
                    <MemberListModal
                        currentMemberList={selectedProjectMemberList}
                        availableMemberList={selectedProjectAvailableMemberList}
                        visible={showMemberListModal}
                        onCancel={this.closeMemberListModal}
                        onMemberAdd={(memberId) => this.handleMemberAdd(memberId)}
                        onMemberRemove={(memberId) => this.handleMemberRemove(memberId)}
                        onMemberAuthChange={(memberId, isAuthorized) => this.handleMemberAuthChange(memberId, isAuthorized)}
                        isAuthorized={isAuthorized}
                    />
                </div>
            )
        }
    }

    renderSider() {
        const { selectedKey } = this.state
        const pathname = location.pathname

        if (pathname === '/workdesk/proposed-project' || pathname === '/workdesk/active-project' || pathname === '/workdesk/template' || pathname === '/workdesk/history')
            return (
                <Sider 
                    className="sider"
                    width={140}
                >
                    <Menu 
                        className="sider-menu"
                        selectedKeys={[selectedKey]}
                    >
                        <MenuItem key="/workdesk/proposed-project">
                            <NavLink to="/workdesk/proposed-project" activeClassName="active-link">Proposed Project</NavLink>
                        </MenuItem>
                        <MenuItem key="/workdesk/active-project">
                            <NavLink to="/workdesk/active-project" activeClassName="active-link">Active Project</NavLink>
                        </MenuItem>
                        <MenuItem key="/workdesk/template">
                            <NavLink to="/workdesk/template" activeClassName="active-link">Template</NavLink>
                        </MenuItem>
                        <MenuItem key="/workdesk/history">
                            <NavLink to="/workdesk/history" activeClassName="active-link">History</NavLink>
                        </MenuItem>
                    </Menu>
                </Sider>
            )
    }

    render() {
        const { userName, loadingStatus } = this.props

        return (
            <Spin spinning={loadingStatus.isLoading} tip={loadingStatus.tip}>
                <Layout className="App">
                        <Header className="header">
                            {this.renderLeftHeader()}
                            <div className="header-right">
                                <div className="user-name">{userName}</div>
                                <Tooltip placement="top" title="Config">
                                    <NavLink to="/workdesk/config">
                                        <img className="header-tool" src={settingIcon} alt="Setting"/>
                                    </NavLink>
                                </Tooltip>
                                <div className="pipeline">|</div>
                                <Tooltip placement="top" title="Logout">
                                    <NavLink to="/">
                                        <img className="header-tool" src={logoutIcon} alt="Logout" onClick={this.handleLogout}/>
                                    </NavLink>
                                </Tooltip>
                            </div>
                        </Header>
                        <Layout className="sider-layout">
                            {this.renderSider()}
                            <Layout>
                                <Content>
                                    {this.props.children}
                                </Content>
                            </Layout>
                        </Layout>
                </Layout>
            </Spin>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
        userId: state.auth.userId,
        userName: state.auth.userName,
        userType: state.auth.userType,
        selectedProject: state.app.selectedProject,
        selectedProjectMemberList: state.app.selectedProjectMemberList,
        selectedProjectAvailableMemberList: state.app.selectedProjectAvailableMemberList,
        loadingStatus: state.app.loadingStatus,
        isMemberAdding: state.app.isMemberAdding,
        isMemberRemoving: state.app.isMemberRemoving,
        isMemberChangingAuth: state.app.isMemberChangingAuth
    }
}

export default connect(mapStateToProps, actions)(App)



// WEBPACK FOOTER //
// ./src/App/App.js